import MovementView from "@/components/MovementView";

export default function Inward() {
  return <MovementView type="inward" />;
}
